import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CSVExport } from "../../components/ui-component/table/CSVExport";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { formatTime, fTimestamp } from "../../../utils/formatTime";

export default function EventAttendeesPopupTable({
  data,
  rowData,
  headerName,
  userReport,
}) {
  const [exportData, setExportData] = useState([]);
  const userRole =localStorage.getItem("userRole")

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_personal_details?.first_name || ""} ${
          params.row?.enquiry_personal_details?.last_name || ""
        }`, // Use direct API fields
      renderCell: (params) => (
        <div
          style={{ color: "#2196f3", cursor: "pointer" }}
          onClick={() =>
            window.open(
              `/enquiry-summary/${params?.row?.enq_personal_details_id}`,
              "_blank"
            )
          }
        >
          {params.row?.enquiry_personal_details?.first_name}{" "}
          {params.row?.enquiry_personal_details?.last_name}
        </div>
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 100,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enquiry_personal_details?.mobile || ""}`,
      renderCell: (params) => (
        <div>{params.row?.enquiry_personal_details?.mobile_country_code}
        {userRole === "advisor" || userRole === "trainer"
          ? params.row?.enquiry_personal_details?.mobile?.replace(/.(?=.{4,}$)/g, "*")
          : params.row?.enquiry_personal_details?.mobile} </div>
      ),
    },
    {
      field: "event_name",
      headerName: "Event Name",
      width: 450,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.event_details?.campaign_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.event_details?.campaign_name} </div>
      ),
    },

    {
      field: "attendance_date",
      headerName: "Attendance Date",
      width: 100,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.created_date || ""}`,
      renderCell: (params) => <div> {params.row?.created_date}</div>,
    },
    {
      field: "attendance_status",
      headerName: "Attendance Status",
      width: 100,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.attendance_status || ""}`,
      renderCell: (params) => <div> {params.row?.attendance_status}</div>,
    },

    {
      field: "is_registered",
      headerName: "Is Registered",
      width: 100,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.is_registered === true ? "Yes" : "No" || ""}`,
      renderCell: (params) => (
        <div>{params.row?.is_registered === true ? "Yes" : "No"} </div>
      ),
    },

    {
      field: "registration_status",
      headerName: "Registration Status",
      width: 150,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.event_registration_details?.registration_status || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.event_registration_details?.registration_status}{" "}
        </div>
      ),
    },

    {
      field: "registration_date",
      headerName: "Registration Date",
      width: 100,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.event_registration_details?.registered_date || ""}`,
      renderCell: (params) => (
        <div>{params.row?.event_registration_details?.registered_date} </div>
      ),
    },
    {
      field: "registrtion_time",
      headerName: "Registration Time",
      width: 100,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.event_registration_details?.registered_time || ""}`,
      renderCell: (params) => (
        <div>
          {params.row.event_registration_details?.registered_time
            ? formatTime(params.row.event_registration_details.registered_time)
            : ""}
        </div>
      ),
    },
    {
      field: "registered_by",
      headerName: "Registered By",
      width: 150,

      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${
          params.row.event_registration_details?.registered_by_details
            ?.first_name || ""
        }{" "}
              ${
                params.row.event_registration_details?.registered_by_details ||
                ""
              }`,
      renderCell: (params) => (
        <div>
          {
            params.row.event_registration_details?.registered_by_details
              ?.first_name
          }{" "}
          {
            params.row.event_registration_details?.registered_by_details
              ?.last_name
          }
        </div>
      ),
    },
  ];

  useEffect(() => {
    const exportData = data.map((row) => ({
      name: row.enquiry_id?.last_name
        ? `${row.enquiry_personal_details.first_name} ${row.enquiry_personal_details.last_name}`
        : row.enquiry_personal_details.first_name,
      mobile: row.enquiry_personal_details.mobile,
      event_name: row?.event_details?.campaign_name,
      attendance_status: row?.attendance_status,
      attendance_date: row?.created_date,
      is_registered: row?.is_registered === true ? "Yes" : "No",
      registration_status: row?.event_registration_details?.registration_status,
      registerd_date: row?.event_registration_details?.registered_date,
      registered_time: row.event_registration_details?.registered_time
        ? formatTime(row?.event_registration_details?.registered_time)
        : "",
      registered_by: row.event_registration_details?.registered_by_details
        ?.last_name
        ? `${row?.event_registration_details?.registered_by_details?.first_name} ${row.event_registration_details?.registered_by_details?.last_name}`
        : row.event_registration_details?.registered_by_details.first_name,
    }));
    setExportData(exportData);
  }, [data]);
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h4">
            {rowData?.event_id?.campaign_name}
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} md={6} textAlign="start" container gap={3}>
          {userReport && (
            <Box display="flex" flexDirection="row">
              <Typography variant="h5">
                {" "}
                Event Registration Report Of {rowData?.user_name}{" "}
              </Typography>{" "}
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={6} textAlign="end">
          <CSVExport
            data={exportData}
            filename={`${headerName} Enquiry Details.csv`}
          />
        </Grid>

        <Grid item xs={12}>
          <DataGrid
            rows={data}
            columns={columns}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
